// extracted by mini-css-extract-plugin
export default {"container":"DesktopAboutUs_container__XN2Pi"};